import { createGlobalStyle } from "styled-components";

const Global = createGlobalStyle`
  body {
    font-family: 'Assistant', sans-serif;
  }
`;

export { Global };
